import createModalModel from './lib/create_modal_model';

export default createModalModel({
  modelName: 'UploadCsv',
  properties: {},
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/modal/upload_csv.js